import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import { useState } from "react";
import scan from "../../assets/module-2/2-2-6-scan.png";
import LdsImage from "../../components/LdsImage";
import FigureCaption from "../../components/LdsFigureCaption";
import References from "../../components/References";
import LdsContentSlider from "../../components/LdsContentSlider/LdsContentSlider";
import scan1 from "../../assets/module-2/2-2-4-scan-1.png";
import scan2 from "../../assets/module-2/2-2-4-scan-2.png";
import scan3 from "../../assets/module-2/2-2-4-scan-3.png";
import scan4 from "../../assets/module-2/2-2-4-scan-4.png";
import scan5 from "../../assets/module-2/2-2-4-scan-5.png";
import scan6 from "../../assets/module-2/2-2-4-scan-6.png";
import LdsBlockSteps from "../../components/LdsBlockSteps";
import IconText from "../../assets/components/blockStep/icon-text.svg";
// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const ImageSlide = ({ src, alt, caption }) => {
  return (
    <div>
      <LdsImage className="content-slider-image" src={src} alt={alt} />
      <FigureCaption
        noCollapse={true}
        className="figcaption-no-border flex-column d-flex"
        radiusSize="small"
      >
        <p className="fz-sm">{caption}</p>
      </FigureCaption>
    </div>
  );
};

const getSlides = () => {
  // Array to hold the images
  const scans = [scan1, scan2, scan3, scan4, scan5, scan6];
  return scans.map((scan, index) => (
    <ImageSlide
      key={index}
      src={scan}
      alt={
        "Transverse brain scan images showing three different views of the brain, with an adjustable slider tool below to view the brain from the bottom to the top."
      }
      caption="©2016. Avid Radiopharmaceuticals, Inc. All rights reserved. Data on file, Lilly Research Laboratories: AMY20121001F."
    />
  ));
};

const Module_2_2_4 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">
              2.2.4 Step 4: Review Every Transverse Image From the Bottom to the
              Top of the Brain
            </h1>
            <p className="me-4">Estimated time to complete: 1 minute</p>
          </section>

          <section className="row mt-5">
            <div className="col-lg-3 col-sm-12 mb-5">
              <LdsBlockSteps
                steps={[
                  {
                    number: 4,
                    color: "blue",
                    icon: IconText,
                    text: "Review every transverse image from the bottom to the top of the brain",
                    boxType: "mid",
                  },
                ]}
              />
            </div>
            <div className="col-lg-8 col-sm-12">
              <div style={{ maxWidth: "600px" }}>
                <LdsContentSlider
                  contentItems={getSlides()}
                  label={
                    "Use the slider tool to view the brain from the bottom to the top"
                  }
                />
                <ul className="ms-0 mt-3">
                  <li>
                    This ensures that cerebellum gray matter will be examined first, which serves as the
                    “normal” reference tissue
                  </li>
                  <li>
                    Temporal and occipital lobes will then be examined
                  </li>
                  <li>
                    Next, the prefrontal cortex will be examined
                  </li>
                  <li>
                    Finally, the parietal cortex will be examined
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <section></section>
          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-2/module-2-2-3", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-2/module-2-2-5", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>
          <References>
            <p className="fz-sm gray">
              Amyvid (florbetapir F 18 injection). Prescribing Information. Lilly
            </p>
          </References>
        </main>
      </div>
    </div>
  );
};

export default Module_2_2_4;
